import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import useDocumentTitle from "utils/useDocumentTitle";
import { object, string } from "yup";

export const useForgotPassword = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [hasError, setHasError] = useState(false);

  useDocumentTitle("Forgot Password");

  const navigate = useNavigate();

  const validationSchema = object({
    phone: string().required("Please Enter Phone Number"),
    email: string(),
    countryCode: string(),
  });

  const form = useForm({
    defaultValues: {
      phone: "",
      email: "",
      countryCode: "+91",
    },
    resolver: yupResolver(validationSchema),
  });

  form.watch();

  const onSubmit = async (value: any) => {
    setIsLoading(true);
    if (hasError) {
      setIsLoading(false);
      toast.error("Please enter a valid phone number.");
      return;
    }
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/otp/${value?.countryCode}-${value?.phone}/send_otp/`,
      {
        email: value.email,
      },
    );
    if (response && response?.status === 200) {
      setIsLoading(false);
      navigate("/login/opt-login", {
        state: {
          phone: value.phone,
          email: value.email,
          isForgetPassword: true,
          countryCode: value?.countryCode,
        },
      });
      toast.success("OTP sent successfully.");
    } else {
      setIsLoading(false);

      toast.error("Something went wrong, please try again.");
    }
  };

  return {
    isLoading,
    navigate,
    form,
    onSubmit,
    hasError,
    setHasError,
  };
};
